module.exports = __webpack_public_path__ + "static/media/20-9.0aff056f.mp3";